<script setup lang="ts">
import { computed, ref } from "vue";

import { getFieldNames } from "./getNames";
import CaseSearchFieldDescription from "./CaseSearchFieldDescription.vue";

import type { TextFilterField } from "@/models/Column";

withDefaults(defineProps<{
  config: TextFilterField;
  fieldPath: string;
  displayName: string;
  isCollection: boolean;
  lastSearch?: { value?: string };
}>(), {  })

const value = ref(__props.lastSearch?.value ?? __props.config.defaultValue ?? "");

const { fieldTypeName, fieldValueName, fieldIsCollectionName, fieldHelpTextId } = getFieldNames(__props.fieldPath, __props.config);

const maxLengthRemainingChars = computed(() => {
  if (__props.config.maxLength == null) return;
  return __props.config.maxLength - value.value.length;
});

const classObject = computed(() => {
  const result: Record<string, object> = {};

  if (maxLengthRemainingChars.value != null) {
    result.maxlength = {
      "tw-text-black": maxLengthRemainingChars.value >= 20,
      "tw-text-red-700 tw-font-medium": maxLengthRemainingChars.value < 20,
    };
  }

  return Object.values(result);
});
</script>
<template>
  <div class="max-w-md tw-relative tw-shrink-0 tw-space-y-1">
    <label
      tabindex="0"
      :for="fieldValueName"
      class="tw-block tw-text-sm tw-font-medium tw-underline-offset-2 tw-outline-none focus:tw-underline"
    >
      {{ displayName }}
    </label>
    <CaseSearchFieldDescription v-if="config.helpText" :id="fieldHelpTextId" :help-text="config.helpText" />
    <div class="tw-relative tw-w-full">
      <input type="hidden" :name="fieldTypeName" value="text" />
      <input type="hidden" :name="fieldIsCollectionName" :value="isCollection" />
      <input
        :id="fieldValueName"
        v-model="value"
        type="text"
        :name="fieldValueName"
        :maxlength="config.maxLength"
        :aria-label="config.description"
        :aria-describedby="config.helpText ? fieldHelpTextId : undefined"
        :placeholder="config.placeholder"
        class="tw-w-full tw-rounded-md tw-border tw-border-gray-500 tw-bg-white tw-p-2"
      />
      <span
        class="tw-absolute"
        :class="classObject"
        :v-if="config.maxLength != null"
        style="right: 6px; top: 50%; transform: translateY(-50%); font-size: 0.65rem"
      >
        {{ maxLengthRemainingChars }}
      </span>
    </div>
  </div>
</template>
